import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {
  ElementsOptions,
  StripeCardComponent,
  ElementOptions,
  StripeService,
} from 'ngx-stripe';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { BillingService } from '../../../lib/services/billingService';

enum PaymentStates {
  preview = 0,
  editing,
  loading,
}

@Component({
  selector: 'mj-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss'],
})
export class PaymentMethodComponent implements OnInit {
  state = PaymentStates.preview;
  error: string;
  elementsOptions: ElementsOptions;
  billingInfo;
  unit_id;
  cardInfo;

  @ViewChild(StripeCardComponent, { static: false })
  card: StripeCardComponent;

  cardForm = new FormGroup({
    name: new FormControl(''),
  });

  cardOptions: ElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        lineHeight: '40px',
        fontWeight: 300,
        fontFamily: '"Avenir", sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0',
        },
      },
    },
  };

  constructor(
    private stripeService: StripeService,
    private billingService: BillingService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.elementsOptions = {
      locale: 'auto',
    };

    this.unit_id = localStorage.getItem('unit_id');
    this.billingService
      .fetchBillingInfo(this.unit_id)
      .pipe(take(1))
      .subscribe(billingInfo => {
        this.cardInfo = billingInfo.sources.data[0];
        this.billingInfo = billingInfo;

        if (!this.cardInfo) {
          this.state = 1;
        }

        this.ref.detectChanges();
      });
  }

  submitCard() {
    this.state = PaymentStates.loading;

    const name = this.cardForm.get('name').value;

    // get token from stripe
    this.stripeService
      .createToken(this.card.getCard(), { name })
      .pipe(take(1))
      .subscribe(result => {
        if (result.token) {
          // send token to backend
          this.billingService
            .updateBillingInfo(this.unit_id, {
              source: result.token.id,
            })
            .pipe(take(1))
            .subscribe(billingInfo => {
              this.cardInfo = billingInfo.sources.data[0];
              this.state = PaymentStates.preview;
              this.ref.detectChanges();
            });
        } else {
          // Error creating the token
          this.state = PaymentStates.editing;
          this.error = result.error.message;
          setTimeout(() => {
            this.error = null;
          }, 6000);
        }
      });
  }

  onCancel() {
    this.cardForm.reset();
    this.state = PaymentStates.preview;
  }

  openEditCard() {
    this.state = PaymentStates.editing;
  }
}
